var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "color-table uk-margin-remove-top uk-table uk-table-divider uk-table-justify"
  }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.$t('fields.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.code')))])]), _vm._v(" "), _c('tbody', _vm._l((_vm.colors), function(color) {
    return _c('tr', {
      key: color.code
    }, [_c('td', [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('td', [_c('color-preview', {
      attrs: {
        "code": color.code
      }
    }), _vm._v("\n        " + _vm._s(color.code) + "\n      ")], 1)])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-700e1fe6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ColorTable.vue
// module id = 2048
// module chunks = 0